module.exports = __webpack_public_path__ + "img/mgh-kyobashi@2x.8ca1cb65.jpg";